function generateRandomDigit() {
    return Math.floor(10000 + Math.random() * 900000);
  }

export {generateRandomDigit}